import { Outlet } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import CollectionsBootstrap from 'modules/expenses/lib/My_cardsCollectionsBootstrap'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const MyCardsPage = () => {
  useEffect(() => {
    track(trackingEvents.procurement.openMyPurchaseRequests)
  }, [])

  return (
    <CollectionsBootstrap>
      <ResponsivePage.Body variant="full">
        <Outlet />
      </ResponsivePage.Body>
    </CollectionsBootstrap>
  )
}

export default MyCardsPage
